// Copied from caloteam/services#v5.59.0 (CountryService), reduced to the methods this app calls.
import { Country, Currency, Kitchen } from '@calo/types';

const getCountryForKitchen = (kitchen: Kitchen): Country => {
  switch (kitchen) {
    case Kitchen.BH1: {
      return Country.BH;
    }
    case Kitchen.SA1:
    case Kitchen.SA2: {
      return Country.SA;
    }
    case Kitchen.KW1: {
      return Country.KW;
    }
    case Kitchen.AE1: {
      return Country.AE;
    }
    case Kitchen.QA1: {
      return Country.QA;
    }
    case Kitchen.OM1: {
      return Country.OM;
    }
    default: {
      return Country.US;
    }
  }
};

const resolveCurrency = (country: Country): Currency => {
  switch (country) {
    case Country.SA: {
      return Currency.SAR;
    }
    case Country.AE: {
      return Currency.AED;
    }
    case Country.KW: {
      return Currency.KWD;
    }
    case Country.QA: {
      return Currency.QAR;
    }
    case Country.OM: {
      return Currency.OMR;
    }
    default: {
      return Currency.BHD;
    }
  }
};

export const CountryService = { getCountryForKitchen, resolveCurrency };
